export enum LookupType {
  Employer = 'Employer',
  HealthcareProvider = 'Health Care Provider',
  HealthcareProviderSupervisory = 'Healthcare Provider Relationship',
  Claimant = 'Claimant',
  Insurer = 'Insurer',
  InsurerExternal = 'Insurer External',
  MedicalSupplier = 'Medical Supplier',
  ThirdPartyAdministrator = 'TPA',
  ThirdPartyAdministratorExternal = 'TPA External',
  SystemUser = 'System User',
  ExternalSystemUser = 'User',
}
